import { useContext } from 'react';
import { NftHeartPillContext } from './NftHeartPillProvider';

export function useNftUserLike(nftItemId: string): {
    userLikeNodeId?: string;
    isNftItemLikedByUser: boolean;
    isRefetching: boolean;
    refetch: () => void;
} {
    const contextValue = useContext(NftHeartPillContext);

    if (!contextValue) {
        throw new Error('Nft HeartPill requires <NftHeartPillProvider />');
    }

    const likeObj = (contextValue.itemLikeData || []).find(obj => obj.nftId === nftItemId);
    return {
        userLikeNodeId: likeObj?.userLikeNodeId,
        isNftItemLikedByUser: !!likeObj?.isLiked,
        isRefetching: contextValue.isRefetching,
        refetch: contextValue.refetch,
    };
}
